export enum BroadcastReduxActions {
    BROADCAST_INITIAL_HANDSHAKE = 'BROADCAST_INITIAL_HANDSHAKE',
    BROADCAST_CLOSE_HANDSHAKE = 'BROADCAST_CLOSE_HANDSHAKE',
    TO_BROADCAST_REDUX_WORKER = 'TO_BROADCAST_REDUX_WORKER',
    TO_DRAFT_REDUX_WORKER = 'TO_DRAFT_REDUX_WORKER',
    BROADCAST_REDUX_MESSAGE = 'BROADCAST_REDUX_MESSAGE',
    TO_REMOVE_BROADCAST_REDUX_MESSAGE = 'TO_REMOVE_BROADCAST_REDUX_MESSAGE',
    TO_CLONE_BROADCAST_REDUX_MESSAGE = 'TO_CLONE_BROADCAST_REDUX_MESSAGE',
    TO_BROADCAST_PROGRESSION_REDUX_MESSAGE = 'TO_BROADCAST_PROGRESSION_REDUX_MESSAGE',
    TO_BROADCAST_PAGELEAVE_REDUX_MESSAGE = 'TO_BROADCAST_PAGELEAVE_REDUX_MESSAGE',
    TO_BROADCAST_AUTH_REDUX_MESSAGE = 'TO_BROADCAST_AUTH_REDUX_MESSAGE',
    TO_BROADCAST_ACTIVE_TAB_MESSAGE = 'TO_BROADCAST_ACTIVE_TAB_MESSAGE',
    BROADCAST_REMOVE_REDUX_MESSAGE = 'BROADCAST_REMOVE_REDUX_MESSAGE',
    BROADCAST_CLONE_REDUX_MESSAGE = 'BROADCAST_CLONE_REDUX_MESSAGE',
    BROADCAST_PROGRESSION_REDUX_MESSAGE = 'BROADCAST_PROGRESSION_REDUX_MESSAGE',
    BROADCAST_PAGELEAVE_REDUX_MESSAGE = 'BROADCAST_PAGELEAVE_REDUX_MESSAGE',
    BROADCAST_AUTH_REDUX_MESSAGE = 'BROADCAST_AUTH_REDUX_MESSAGE',
    BROADCAST_ACTIVE_TAB_MESSAGE = 'BROADCAST_ACTIVE_TAB_MESSAGE',
}
const SetBroadcastCloseHandshake = (payload: any): any => ({
    type: BroadcastReduxActions.BROADCAST_CLOSE_HANDSHAKE,
    payload,
});
const SetBroadcastReduxMessage = (payload: any): any => ({
    type: BroadcastReduxActions.BROADCAST_REDUX_MESSAGE,
    payload,
});
const SetRemoveBroadcastReduxMessage = (payload: any): any => ({
    type: BroadcastReduxActions.BROADCAST_REMOVE_REDUX_MESSAGE,
    payload,
});
const SetCloneBroadcastReduxMessage = (payload: any): any => ({
    type: BroadcastReduxActions.BROADCAST_CLONE_REDUX_MESSAGE,
    payload,
});

const SetBroadcastInitialHandshake = (payload: any): any => ({
    type: BroadcastReduxActions.BROADCAST_INITIAL_HANDSHAKE,
    payload,
});

const SetBroadcastReduxDraft = (payload: any): any => ({
    type: BroadcastReduxActions.TO_DRAFT_REDUX_WORKER,
    payload,
});

const SetBroadcastProgression = (payload: any): any => ({
    type: BroadcastReduxActions.BROADCAST_PROGRESSION_REDUX_MESSAGE,
    payload,
});

const SetBroadcastPageLeave = (payload: any): any => ({
    type: BroadcastReduxActions.BROADCAST_PAGELEAVE_REDUX_MESSAGE,
    payload,
});

const setBroadcastAuthData = (payload: any): any => ({
    type: BroadcastReduxActions.BROADCAST_AUTH_REDUX_MESSAGE,
    payload,
});

const setBroadcastActiveTab = (payload: any): any => ({
    type: BroadcastReduxActions.BROADCAST_ACTIVE_TAB_MESSAGE,
    payload,
});

export const BroadcastActions = {
    SetRemoveBroadcastReduxMessage,
    SetCloneBroadcastReduxMessage,
    SetBroadcastCloseHandshake,
    SetBroadcastInitialHandshake,
    SetBroadcastReduxDraft,
    SetBroadcastReduxMessage,
    SetBroadcastProgression,
    SetBroadcastPageLeave,
    setBroadcastAuthData,
    setBroadcastActiveTab,
};
